(() => {
  if (window.__vrPdp) return;
  window.__vrPdp = true;

  const fmt = (paise, cur) =>
    new Intl.NumberFormat('en-IN', { style: 'currency', currency: cur || 'INR', minimumFractionDigits: paise % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(paise / 100);
  const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  let variants;
  const allVariants = () => {
    if (!variants) {
      try { variants = JSON.parse(document.querySelector('script[data-vr-variants]').textContent); } catch (e) { variants = []; }
    }
    return variants;
  };
  const picker = () => document.querySelector('variant-picker[data-template-product-match="true"]');

  const selectedOptions = () => {
    const p = picker();
    if (!p) return null;
    return [...p.querySelectorAll('.variant-option')].map((o) => {
      const sel = o.querySelector('select');
      if (sel) return sel.value;
      const r = o.querySelector('input:checked');
      if (r) return r.value;
      return o.querySelector('.variant-option__swatch-value')?.textContent.trim();
    });
  };
  const findVariant = () => {
    const o = selectedOptions();
    if (!o) return null;
    return allVariants().find((v) => v.options.every((x, i) => x === o[i])) || null;
  };

  const applyPrice = (v) => {
    document.querySelectorAll('product-price').forEach((pp) => {
      if (pp.closest('product-card, product-recommendations, .sticky-add-to-cart, quick-add-dialog')) return;
      const box = pp.querySelector('[ref="priceContainer"]');
      if (!box) return;
      const mk = (cls, label, text) => {
        const g = document.createElement('span');
        g.className = 'price-item__group ' + cls;
        const h = document.createElement('span');
        h.className = 'visually-hidden';
        h.textContent = label + ' ';
        const b = document.createElement('bdi');
        b.textContent = text;
        g.append(h, b);
        return g;
      };
      box.replaceChildren();
      if (v.compare > v.price) {
        box.append(mk('price', 'Sale price', v.priceFmt), mk('price-item--regular compare-at-price', 'Regular price', v.compareFmt));
        const o = document.createElement('span');
        o.className = 'price-off';
        o.textContent = Math.round(((v.compare - v.price) * 100) / v.compare) + '% off';
        box.append(o);
      } else {
        box.append(mk('price', 'Regular price', v.priceFmt));
      }
    });
  };

  const applyGallery = (v) => {
    if (!v.media) return;
    const mg = document.querySelector('media-gallery');
    const ss = mg && mg.slideshow;
    if (!ss || typeof ss.select !== 'function') return;
    const slides = [...mg.querySelectorAll('slideshow-slide')];
    const i = slides.findIndex((s) => s.querySelector('[data-media-id="' + v.media + '"]'));
    if (i > -1) ss.select(i, undefined, { animate: false });
  };

  // Update the UI right away from local data; the server response (below) only reconciles.
  document.addEventListener(
    'change',
    (e) => {
      const t = e.target;
      if (!(t instanceof Element) || !t.closest('variant-picker') || t.closest('product-card, quick-add-dialog')) return;
      const v = findVariant();
      if (!v) return;
      applyPrice(v);
      applyGallery(v);
      document.dispatchEvent(new CustomEvent('vr:variant', { detail: v }));
    },
    true
  );

  // Ask the server for only the product section (not the whole page) when a variant changes,
  // and tell the pay-offers box when the cart changes.
  const nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    let url = typeof input === 'string' ? input : input && input.url;
    try {
      if (url && url.includes('option_values=') && !url.includes('section_id=')) {
        const p = picker();
        const u = new URL(url, location.origin);
        const connected = p && p.querySelector('[data-connected-product-url]:not([data-connected-product-url=""])');
        if (p && p.dataset.sectionId && !connected && u.pathname === new URL(p.dataset.productUrl, location.origin).pathname) {
          u.searchParams.set('section_id', p.dataset.sectionId);
          input = typeof input === 'string' ? u.pathname + u.search : new Request(u.toString(), input);
        }
      }
    } catch (e) {}
    const res = nativeFetch.call(this, input, init);
    if (url && /\/cart\/(add|change|update|clear)/.test(url)) {
      res.then(() => setTimeout(() => document.dispatchEvent(new Event('vr:cart')), 150)).catch(() => {});
    }
    return res;
  };

  // One element, two blocks: data-mode="pay" shows the prepaid line, data-mode="offers" the progress bar.
  class VrPayOffers extends HTMLElement {
    connectedCallback() {
      const d = this.dataset;
      this.cur = d.currency || 'INR';
      this.pct = Number(d.prepaid) || 0;
      this.useCart = d.includeCart === 'true';
      this.cart = this.useCart ? Number(d.cartTotal) || 0 : 0;
      this.tiers = [1, 2, 3]
        .map((i) => ({ amt: (Number(d['t' + i + 'Amt']) || 0) * 100, label: d['t' + i + 'Label'] || '' }))
        .filter((t) => t.amt > 0 && t.label)
        .sort((a, b) => a.amt - b.amt);
      this.variant = allVariants().find((v) => String(v.id) === d.variant) || findVariant();
      this.onVariant = (e) => { this.variant = e.detail; this.render(); };
      this.onCart = () => this.refreshCart();
      this.onQty = (e) => { if (e.target && e.target.name === 'quantity') this.render(); };
      this.onClick = (e) => { if (e.target.closest && e.target.closest('quantity-selector-component')) setTimeout(() => this.render(), 60); };
      document.addEventListener('vr:variant', this.onVariant);
      document.addEventListener('vr:cart', this.onCart);
      document.addEventListener('cart:update', this.onCart);
      document.addEventListener('input', this.onQty);
      document.addEventListener('change', this.onQty);
      document.addEventListener('click', this.onClick);
      this.render();
      if (this.useCart) this.refreshCart();
    }
    disconnectedCallback() {
      document.removeEventListener('vr:variant', this.onVariant);
      document.removeEventListener('vr:cart', this.onCart);
      document.removeEventListener('cart:update', this.onCart);
      document.removeEventListener('input', this.onQty);
      document.removeEventListener('change', this.onQty);
      document.removeEventListener('click', this.onClick);
    }
    refreshCart() {
      if (!this.useCart) return this.render();
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((c) => { this.cart = c.items_subtotal_price || 0; this.render(); })
        .catch(() => {});
    }
    qty() {
      const q = document.querySelector('product-form-component input[name="quantity"], form[action*="/cart/add"] input[name="quantity"]');
      return Math.max(1, parseInt(q && q.value, 10) || 1);
    }
    render() {
      const v = this.variant;
      if (!v) { this.hidden = true; return; }
      this.hidden = false;
      const line = v.price * this.qty();
      const total = line + this.cart;
      const f = (n) => fmt(Math.round(n), this.cur);
      const low = (s) => s.charAt(0).toLowerCase() + s.slice(1);
      let html = '';
      if (this.pct > 0) {
        const pay = Math.round((line * (100 - this.pct)) / 100);
        const code = this.dataset.code ? ' · Code <span class="vr-pay__code">' + esc(this.dataset.code) + '</span>' : '';
        html = '<p class="vr-pay__online"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2.5" y="5" width="19" height="14" rx="2.5"/><path d="M2.5 10h19M6 15h4"/></svg><span>Get it for <b>' + f(pay) + '</b> with ' + this.pct + '% prepaid' + code + '</span></p>';
      }
      const T = this.tiers;
      if (T.length) {
        const max = T[T.length - 1].amt;
        const next = T.find((t) => total < t.amt);
        const got = T.filter((t) => total >= t.amt);
        let msg;
        if (!next) msg = '🎉 ' + esc(T[T.length - 1].label) + ' unlocked. You have every offer!';
        else if (got.length) msg = '🎉 ' + esc(got[got.length - 1].label) + ' unlocked. Add ' + f(next.amt - total) + ' more for ' + esc(low(next.label)) + '.';
        else msg = 'Add ' + f(next.amt - total) + ' more to get ' + esc(low(next.label)) + '.';
        const pos = (t) => (t.amt / max) * 100;
        const pct = Math.min(total / max, 1) * 100;
        let o = '<p class="vr-pay__msg">' + msg + '</p>';
        o += '<div class="vr-pay__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '"><span class="vr-pay__fill" style="width:' + pct + '%"></span>';
        T.forEach((t) => { o += '<span class="vr-pay__dot' + (total >= t.amt ? ' is-on' : '') + '" style="left:' + pos(t) + '%"></span>'; });
        o += '</div><div class="vr-pay__labels">';
        T.forEach((t, i) => { o += '<div class="vr-pay__lab' + (i === T.length - 1 ? ' is-last' : '') + '" style="left:' + pos(t) + '%"><b>' + f(t.amt) + '</b><span>' + esc(t.label) + '</span></div>'; });
        o += '</div>';
        html += '<div class="vr-pay__offers">' + o + '</div>';
      }
      this.innerHTML = html ? '<div class="vr-pay__card">' + html + '</div>' : '';
    }
  }
  if (!customElements.get('vr-pay-offers')) customElements.define('vr-pay-offers', VrPayOffers);
})();